<template>
  <div class="notifications-stack">
    <transition-group name="slide-up">
      <Notification
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        @dismiss="removeNotification"
      />
    </transition-group>
  </div>
</template>
<script>
import Notification from "./notification";
/*
    type Notification = {
        id: null|number|string;
        title: string;
        description: string|null;
        icon: string|null;
        type: 'success'|'error'|'warning'|'info';
        timeout: number;
        actions: Array<{
            id: null|number|string;
            title: string;
            btnClass: string|null;
            handler: Function|String|Object|null;
        }>;
    };
*/

export default {
  name: "Notifications",
  components: {
    Notification,
  },
  data() {
    return {
      notifications: [],
    };
  },
  created() {
    this.$root.$on("notify", (notification) => {
      this.addNotification(notification);
    });

    // window.notify function
    window.$notify = (notification) => {
      this.addNotification(notification);
    };
  },
  methods: {
    addNotification(notification) {
      notification.id = this.uuid();

      notification.message =
        notification.message || notification.description || null;

      if (notification.type == "error") {
        notification.type = "danger";
      }

      this.notifications.push(notification);

      // vibrate the device
      if ("vibrate" in navigator) {
        navigator.vibrate(10);
      }
    },
    removeNotification(id) {
      this.notifications = this.notifications.filter((item) => item.id !== id);
    },
  },
};
</script>
<style lang="scss" scoped>
.notifications-stack {
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 998;
  width: 100%;
  max-width: 440px;
  padding: 0 0.8rem;
  padding-bottom: 1rem;
  box-sizing: border-box;
  transform: translateX(-50%);
  transition: all 0.3s ease-in-out;
}
</style>